var _circle, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E2E8F0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 25,
    rx: 12,
    ry: 15,
    fill: "#475569"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9961 54.2526C49.1785 60.2633 41.0256 64 31.9999 64C23.2657 64 15.3488 60.5008 9.57465 54.8278C13.7175 49.0084 22.4266 45 32.4998 45C42.2376 45 50.7006 48.7459 54.9961 54.2526Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 39.9486C39.1595 39.3134 44 32.8633 44 24.9999C44 17.131 39.1525 10.6772 32.9867 10.0499L29 25H33V39.9486Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultAvatar);
export default __webpack_public_path__ + "static/media/icon-default-avatar.31ca73affc78db02207ae78afb98b063.svg";
export { ForwardRef as ReactComponent };